import { JSResourceForUserVisible } from '@atlassian/react-async';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const classicBoardSettingsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(
			/* webpackChunkName: "async-classic-board-settings-entrypoint" */ './src/BoardSettingsSwitcher.tsx'
		).then(({ BoardSettingsSwitcher }) => BoardSettingsSwitcher),
	),
	getPreloadProps: () => {
		return {};
	},
});
